export enum Actions{
    ADD = "ADD_FS",
    REMOVE = "REMOVE_FS",
    CHANGE = "CHANGE_FS"
}